import { atom } from 'recoil'

import { healthClaimFormProps } from './types'
import { HealthClaimModeEnum } from '@/constant/E_CLAIM'

const initDefault: healthClaimFormProps = {
  mode: HealthClaimModeEnum.VIEW,
  reclaim: false,
  hasRequestedDocuments: false, // Default to false, indicating no documents have been requested
  pendingRequestDocuments: [],
  draft: undefined,
  selectedPolicyNumberOverride: null,
  pendingValidation: undefined,
}

const healthClaimFormAtom = atom({
  key: 'healthClaimFormAtom',
  default: initDefault,
})

export default healthClaimFormAtom
